import { FormikProps } from 'formik'
import Button from '@mui/material/Button'

import { Output, PortMode, PortType } from 'common/api/v1/types'
import { GridItem } from '../../../common/Form'
import IpPortForm from './IpPortForm'
import CoaxPortForm from './CoaxPortForm/CoaxPortForm'
import NdiForm from './NdiForm'
import EncoderSettings from '../EncoderSettings'
import { PhysicalPortInfoWithAppliance } from '../../../../api/nm-types'

interface IPortFormProps {
  form: FormikProps<Output>
  index: number
  physicalPort: PhysicalPortInfoWithAppliance
  isModeDisabled: boolean
  namePrefix: string
  enforcedPortMode: PortMode | undefined
  onRemoveLogicalPortRequested: () => void
  onAddLogicalPortRequested: () => void
}

export const PortForm = ({
  physicalPort,
  isModeDisabled,
  namePrefix,
  enforcedPortMode,
  form,
  index,
  onAddLogicalPortRequested,
  onRemoveLogicalPortRequested,
}: IPortFormProps) => {
  return (
    <>
      {physicalPort.portType === PortType.ip && (
        <IpPortForm
          namePrefix={namePrefix}
          form={form}
          addresses={physicalPort.addresses}
          applianceType={physicalPort.appliance.type}
          applianceVersion={physicalPort.appliance.version}
          applianceFeatures={physicalPort.appliance.features}
          index={index}
          occupiedPorts={physicalPort.occupiedPorts}
          isModeDisabled={isModeDisabled}
          enforcedPortMode={enforcedPortMode}
          onAddLogicalPortRequested={onAddLogicalPortRequested}
          onRemoveLogicalPortRequested={onRemoveLogicalPortRequested}
        />
      )}

      {physicalPort.portType === PortType.coax && (
        <CoaxPortForm
          physicalPortIndex={physicalPort.index ?? 'Missing port index'}
          namePrefix={namePrefix}
          settings={physicalPort.appliance.settings}
          form={form}
          applianceFeatures={physicalPort.appliance.features}
        />
      )}

      {physicalPort.portType === PortType.ndi && <NdiForm namePrefix={namePrefix} form={form} />}

      <GridItem newLine>
        <Button style={{ marginTop: 12 }} variant="outlined" color="primary" onClick={onRemoveLogicalPortRequested}>
          Remove interface
        </Button>
      </GridItem>

      <EncoderSettings form={form} namePrefix={namePrefix} applianceFeatures={physicalPort.appliance.features} />
    </>
  )
}
